import React from "react";
import albert from "../../assets/img/albert.png";
import licinda from "../../assets/img/lucinda.png";

const Team = () => {
  return (
    <div className="bg-soft container-fluid p-0 p-lg-5">
      <h2 className="fs-40 fs-700 text-center mb-5 p-3 p-lg-0">
        Meet your dentist
      </h2>
      {/* <p className="fs-16 text-center mb-5">People who made us successful</p> */}

      <div className="container py-5">
        <div className="row  justify-content-center ">
          <div className="col-12 col-md-10 mb-4 text-center ">
            <img
              src={licinda}
              alt="naeem"
              className="img-fluid mb-3 mx-auto rounded-4"
            />
            <h3 className="fs-36 fw-600">Dr. Naeem Asfhaq</h3>
            <p className="fs-14">
              Cosmetic Dentist |{" "}
              <a
                className="text-dark"
                href="https://olr.gdc-uk.org/SearchRegister/SearchResult?RegistrationNumber=283591"
                target="blank"
              >
                GDC No 283591
              </a>{" "}
              | BDS (2019)
            </p>
            <p className="fs-14 text-start px-3 px-md-0">
              Dr. Naeem is a compassionate and skilled general dentist dedicated
              to delivering exceptional patient care. A graduate of the
              University of Manchester in 2019, Dr Naeem brings extensive
              experience in oral surgery, having worked in a hospital setting
              where they handled complex soft and hard tissue cases.
              <br />
              <br />
              With a passion for enhancing smiles, Dr. Naeem is also a highly
              trained cosmetic dentist, offering treatments such as composite
              bonding, porcelain veneers, teeth whitening, and Invisalign.
              Beyond aesthetics, Dr. Naeem is experienced in rehabilitating
              patients’ mouths, providing solutions for tooth wear and restoring
              broken-down teeth to their optimal health and function.
              <br />
              <br />
              Dr. Naeem is committed to creating a comfortable, relaxing
              environment for patients and is especially skilled in treating
              those who may feel nervous or anxious about dental visits.
              Understanding each patient’s unique needs, Dr. Naeem ensures that
              every treatment is as stress-free and enjoyable as possible.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
